import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import CandidateFollowup from "./Cc";
import RecentJobs from "./RecentJobs";
import Card from "./Card";
// import "./Homev2.css" // Assuming this CSS file exists and contains necessary styles

const CompanyProfile = ({ activeMain, setActiveMain }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const companyID = new URLSearchParams(location.search).get("companyID");

    const [showDropdown, setShowDropdown] = useState(false);
    const [showPopup, setShowPopup] = useState(false); // This seems unused based on the commented out UploadPopup
    const [schedules, setSchedules] = useState([]);
    const [interviewScheduledToday, setInterviewScheduledToday] = useState(0);
    const [totalInterviewScheduled, setTotalInterviewScheduled] = useState(0);
    const [loading, setLoading] = useState(true);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [company, setCompany] = useState({});
    const [jobs, setJobs] = useState([]);

    // Function to fetch company details by ID
    const fetchCompanyByID = async (id) => {
        try {
            console.log("companyID", id);
            const response = await fetch(`/api/get_company_by_ID?companyID=${encodeURIComponent(id)}`, {
                method: "GET",
            });
            if (!response.ok) {
                throw new Error("Failed to fetch company");
            }
            const data = await response.json();
            console.log("Company Data:", data);
            setCompany(data);
            return data;
        } catch (error) {
            console.error("Error fetching company:", error);
            return null;
        }
    };

    // Function to fetch upcoming schedules for a company email
    const fetchUpcomingSchedule = async (companyEmail) => {
        if (!companyEmail) return; // Don't fetch if email is not available
        try {
            const url = `/api/company_upcoming_schedules?company_email=${encodeURIComponent(companyEmail)}`;
            const response = await fetch(url, {
                method: "POST", // Although GET seems more appropriate for fetching, sticking to POST as in original
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            setTotalInterviewScheduled(data.length);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            let todayCount = 0;
            const upcomingSchedules = data.filter(schedule => {
                const scheduleDate = new Date(schedule.scheduled_time);
                if (scheduleDate.toDateString() === today.toDateString()) {
                    todayCount++;
                }
                return scheduleDate >= today;
            });

            setInterviewScheduledToday(todayCount); // Set the count after filtering
            console.log("Upcoming schedules:", upcomingSchedules);
            setSchedules(upcomingSchedules);
        } catch (error) {
            console.error("Error fetching upcoming schedule:", error);
        }
    };

    // Function to fetch jobs for a company email
    const fetchJobs = async (companyEmail) => {
        if (!companyEmail) return; // Don't fetch if email is not available
        try {
            const url = `/api/get_jd?company_email=${encodeURIComponent(companyEmail)}`;
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();
            setJobs(data);
        } catch (error) {
            console.error("Error fetching jobs:", error);
        }
    };

    // Main useEffect to handle data fetching in sequence
    useEffect(() => {
        const loadCompanyData = async () => {
            setLoading(true);
            const fetchedCompany = await fetchCompanyByID(companyID);
            if (fetchedCompany && fetchedCompany.email) {
                await fetchJobs(fetchedCompany.email);
                await fetchUpcomingSchedule(fetchedCompany.email);
            }
            setLoading(false);
        };

        if (companyID) {
            loadCompanyData();
        }
    }, [companyID]); // Re-run when companyID changes

    // Effect for handling external clicks to close dropdown
    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (!e.target.closest('.post-job-dropdown')) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []); // Only run once on mount for event listener

    // Effect to show delete popup based on activeMain prop
    useEffect(() => {
        if (activeMain === "delete-company-profile") {
            setShowDeletePopup(true);
        }
        console.log(location.state);
    }, [activeMain, location.state]);

    // Toggle dropdown visibility
    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    // Handle JD Actions
    const handleCreateJD = () => {
        navigate('/jd');
        setShowDropdown(false);
    };

    const handleGenerateJD = () => {
        navigate('/generate-jd-ai');
        setShowDropdown(false);
    };

    const handleUploadJD = () => {
        navigate('/uploadjd');
        setShowDropdown(false);
    };

    const handleClosePopup = () => {
        setShowPopup(false); // This seems related to a commented out UploadPopup
        setShowDeletePopup(false);
        setActiveMain("company-profile"); // Reset activeMain to hide delete popup
    };

    const handleApplicantClick = (jobId) => {
        navigate(`/ranking?jobID=${encodeURIComponent(jobId)}`, { state: { jobID: jobId } });
    };

    const convertToIST = (gmtDate) => {
        const date = new Date(gmtDate);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'Asia/Kolkata', // Set to IST (Indian Standard Time)
        };
        return date.toLocaleString('en-IN', options);
    };

    if (loading) {
        return (
            <div className="loader-container">
                <div className="spinner"></div>
            </div>
        );
    }

    return (
        <>
            <div className="homev2">
                <div className="welcome-section-v2">
                    <h1>{company.company_name}</h1>

                    <div className="post-job-dropdown">
                        <button className="post-job-btn-v2-ch" onClick={toggleDropdown}>Post Job ▾</button>

                        {showDropdown && (
                            <div className="dropdown-menu">
                                <button className="dropdown-item" onClick={handleCreateJD}>
                                    Create JD
                                </button>
                                <button className="dropdown-item" onClick={handleGenerateJD}>
                                    Generate JD with AI
                                </button>
                                <button className="dropdown-item" onClick={handleUploadJD}>
                                    Upload JD
                                </button>
                            </div>
                        )}
                    </div>

                    {/* {showPopup && <UploadPopup onClose={handleClosePopup} onUpload={handleUploadJD} />} */}
                </div>
                <div className="dashboard-container">
                    <div className="cards-container">
                        {/* Note: The counts for "Active Jobs", "New Applications", "Selected Candidate" are hardcoded as "04" and "08".
                            You might want to replace these with actual data fetched from your APIs based on the company. */}
                        <Card title="Active Jobs" colour="#ffefe7" count={jobs.length} icon="https://cdn.builder.io/api/v1/image/assets/TEMP/1b893a3259dbf8002a9df3d65c98b2591e2771f956e6e7d35a82933adf42f3a4?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
                        <Card title="New Applications" colour="#e8f0fb" count="04" icon="https://cdn.builder.io/api/v1/image/assets/TEMP/69e937a765c8fb30968aa24f48e1ed3744a9ff20b53d0eab01cf2340dde09514?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
                        <Card title="Selected Candidate" colour="#fdebf9" count="08" icon="https://cdn.builder.io/api/v1/image/assets/TEMP/5df09de77d8009c9989329c66924319c0dfbeeddcf49a87bc021f3d4a17b9048?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
                        <Card title="No. of Interviews Done" colour="#d1f5fd" count={totalInterviewScheduled - schedules.length} icon="https://cdn.builder.io/api/v1/image/assets/TEMP/15623d03a83826a360c6393aaaa3a42f609bcc72d517b820ebea3454a9bb5c80?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
                        <Card title="Interview Scheduled Today" colour="#d9ffe2" count={interviewScheduledToday} icon="https://cdn.builder.io/api/v1/image/assets/TEMP/7430cb9d6ec5b3476b0a3d2e3835948fb77f85cb87835a6aa517e06a948e10f1?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
                    </div>
                    <div className="ddashboard">
                        <div className="dchart">
                            <div className="chart-section-v2-trial">
                                <div className="chart-header-v2">
                                    <h2>Overview of Active Jobs</h2>
                                    <div className="chart-filter-v2">
                                        <span>Month</span>
                                        <img
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/2921160c9100cfc9e9704213dae0ba0daecd34621dab47297f1e437d36bd0640?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4"
                                            alt=""
                                            className="filter-icon-v2"
                                        />
                                    </div>
                                </div>
                                <div className="chart-divider-v2"></div>
                                <div className="chart-content-v2">
                                    <div className="chart-y-axis-v2">
                                        <span>80</span>
                                        <span>60</span>
                                        <span>40</span>
                                        <span>20</span>
                                        <span>00</span>
                                    </div>
                                    <div className="chart-bars-v2">
                                        <div className="bar-group-v2">
                                            <div className="bar-v2 bar-saved-v2"></div>
                                            <div className="bar-v2 bar-new-v2"></div>
                                            <div className="bar-v2 bar-interviewed-v2"></div>
                                            <div className="bar-v2 bar-reviewed-v2"></div>
                                            <div className="bar-v2 bar-shortlist-v2"></div>
                                        </div>
                                        <div className="chart-legend-v2">
                                            <div className="legend-item-v2">
                                                <div className="legend-color-v2 new-v2"></div>
                                                <span>New</span>
                                            </div>
                                            <div className="legend-item-v2">
                                                <div className="legend-color-v2 interviewed-v2"></div>
                                                <span>Interviewed</span>
                                            </div>
                                            <div className="legend-item-v2">
                                                <div className="legend-color-v2 reviewed-v2"></div>
                                                <span>Reviewed</span>
                                            </div>
                                            <div className="legend-item-v2">
                                                <div className="legend-color-v2 shortlist-v2"></div>
                                                <span>Shortlist</span>
                                            </div>
                                            <div className="legend-item-v2">
                                                <div className="legend-color-v2 saved-v2"></div>
                                                <span>Saved</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="dschedule">
                            <div className="schedule-section-v2-trial">
                                <div className="schedule-header-v2">
                                    <h2>Upcoming Candidate Interviews</h2>
                                </div>
                                <div className="schedule-list-v2">
                                    <div>
                                        {schedules.length === 0 ? (
                                            <p>No upcoming schedules available.</p>
                                        ) : (
                                            schedules.map((schedule, index) => (
                                                <div key={index} className="schedule-item-v2">
                                                    <div className="schedule-content-v2">
                                                        <p><strong>
                                                            {schedule.topic}{" "}
                                                            {schedule.test_type === "t" && "(Technical Test)"}
                                                            {schedule.test_type === "p" && "(Personality Test)"}
                                                            {schedule.test_type === "b" && "(Behavioral Test)"}
                                                            {schedule.test_type === "c" && "(Coding Test)"}
                                                        </strong>
                                                        </p>

                                                        <p>Candidate Name(s):</p>
                                                        {schedule.full_names
                                                            ?.split(", ")
                                                            .map((name, i) => (
                                                                <p key={i}>
                                                                    {i + 1}. {name}
                                                                </p>
                                                            ))}

                                                        <span>Scheduled Time: {convertToIST(schedule.scheduled_time)}</span>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="dposts">
                            <RecentJobs jobs={jobs} setActiveMain={setActiveMain} />
                        </div>
                        <div className="djobs">
                            <CandidateFollowup maxHeight={400} companyEmail={company.email} />
                        </div>
                    </div>
                </div>
                {showDeletePopup && (
                    <div className="popup-overlay-res">
                        <div className="popup-container">
                            <h2>Delete Job</h2> {/* This says "Delete Job" but implies deleting company */}
                            <p>All data belonging to the NewZenAlpha will be lost. Are you sure about Deleting the Company?</p>
                            <div className="popup-buttons">
                                <button className="popup-button cancel" onClick={handleClosePopup}>
                                    Cancel
                                </button>
                                <button className="popup-button upload">
                                    Delete Company
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default CompanyProfile;